(function(global) {
    document.onkeyup = function(e) {
        if (e.which == 124) {
            var body = document.querySelector('body');
            global.methods.toggleAttributeValue(body, 'gr-debug', 'outline');
        }
    };
})(window.groots);
